export default __webpack_public_path__ + "static/media/589.30684a88.png";